import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles'
import React from 'react'

/* Inspired by http://jsfiddle.net/noahbuscher/wc9yzk9y/3/ */
const styles = () =>
  createStyles({
    loader: {
      width: '100px',
      height: '100px',
      padding: '15px',
      backgroundColor: 'rgba(0, 0, 0, 0.65)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '20%',
    },
    data: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    bars: {
      width: '32px',
      height: '33px',
      paddingLeft: '5px',
    },
    info: {
      color: '#C0BEBE',
      textAlign: 'center',
      fontSize: '13px',
      marginTop: '3px',
    },
    bar: {
      width: '5px',
      minHeight: '11%',
      backgroundColor: 'white',
      borderRadius: '1px',
      borderWidth: '0px',
      marginRight: '3px',
      display: 'inline-block',
      verticalAlign: 'baseline',
    },
    barOne: {
      height: '11px',
      animation: '$one 5s infinite',
    },
    barTwo: {
      height: '22px',
      animation: '$two 5s infinite',
    },
    barThree: {
      height: '33px',
      animation: '$three 5s infinite',
    },
    '@keyframes one': {
      '0%': { height: '11px', marginTop: '22px' },
      '17%': { height: '22px', marginTop: '11px' },
      '33%': { height: '33px', marginTop: '0' },
      '50%': { height: '11px', marginTop: '22px' },
      '67%': { height: '22px', marginTop: '11px' },
      '83%': { height: '33px', marginTop: '0' },
      '100%': { height: '11px', marginTop: '22px' },
    },
    '@keyframes two': {
      '0%': { height: '33px', marginTop: '0' },
      '17%': { height: '11px', marginTop: '22px' },
      '33%': { height: '22px', marginTop: '11px' },
      '50%': { height: '33px', marginTop: '0' },
      '67%': { height: '11px', marginTop: '22px' },
      '83%': { height: '22px', marginTop: '11px' },
      '100%': { height: '33px', marginTop: '0' },
    },
    '@keyframes three': {
      '0%': { height: '22px', marginTop: '11px' },
      '17%': { height: '33px', marginTop: '0' },
      '33%': { height: '11px', marginTop: '22px' },
      '50%': { height: '22px', marginTop: '11px' },
      '67%': { height: '33px', marginTop: '0' },
      '83%': { height: '11px', marginTop: '22px' },
      '100%': { height: '22px', marginTop: '11px' },
    },
  })

interface IProps extends WithStyles {
  loadingMessage: string
}

const AnimatedLoader = ({ loadingMessage, classes }: IProps) => {
  return (
    <div className={classes.loader}>
      <div className={classes.data}>
        <div className={classes.bars}>
          <div className={classes.bar + ' ' + classes.barOne} />
          <div className={classes.bar + ' ' + classes.barTwo} />
          <div className={classes.bar + ' ' + classes.barThree} />
        </div>
        <div className={classes.info}>{loadingMessage}</div>
      </div>
    </div>
  )
}

export default withStyles(styles)(AnimatedLoader)
